import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { groupsAPI } from '../api/client';
import '../styles/auth.css';

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  return (parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : name[0]).toUpperCase();
}

export default function JoinGroup() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState('');
  const isLoggedIn = !!localStorage.getItem('token');

  useEffect(() => {
    groupsAPI.getByInviteToken(token)
      .then(r => setGroup(r.data))
      .catch(() => setError('This invite link is invalid or has expired.'))
      .finally(() => setLoading(false));
  }, [token]);

  const handleJoin = async () => {
    if (!isLoggedIn) {
      navigate(`/login?redirect=/join/group/${token}`);
      return;
    }
    setJoining(true);
    try {
      await groupsAPI.joinByToken(token);
      navigate('/groups');
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to join group.');
    }
    setJoining(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card-inner">
          <span className="auth-logo">covo</span>

          {loading ? (
            <p style={{ textAlign: 'center', color: '#888' }}>Loading…</p>
          ) : error ? (
            <>
              <h1 className="auth-heading">Invalid link</h1>
              <p className="auth-sub">{error}</p>
              <button className="btn-primary" onClick={() => navigate('/')}>Go home</button>
            </>
          ) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: '#52AAD8', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 24, fontWeight: 700, fontFamily: 'DM Sans, sans-serif',
                }}>
                  {getInitials(group.name)}
                </div>
              </div>

              <h1 className="auth-heading">{group.name}</h1>
              <p className="auth-sub">
                {group.member_count} {group.member_count === 1 ? 'member' : 'members'} · You've been invited to join this group.
              </p>

              {error && <div className="error-message">{error}</div>}

              <button className="btn-primary" onClick={handleJoin} disabled={joining}>
                {joining ? 'Joining…' : isLoggedIn ? 'Join group' : 'Log in to join'}
              </button>

              <p className="auth-link" style={{ marginTop: 12 }}>
                <button
                  style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 14 }}
                  onClick={() => navigate('/')}
                >
                  Not now
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
